import React from "react";
import { createRoot } from "react-dom/client";
import Integration from "./components/Integration";

const DEFAULT_PARTNER = "merkur";
const DEFAULT_LANGUAGE = "new_language_provider";
const flow_registration = "registration";
const flow_login = "login";
const flow_customer_login = "customer_login";
const smart_check_in = "smart_check_in";

export function init({ partner, language }) {
  partner = partner || DEFAULT_PARTNER;
  language = language || DEFAULT_LANGUAGE;
  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);

  document.body.style.overflow = "hidden";

  Array.from(document.getElementsByTagName("video")).forEach((video) => {
    video.pause();
  });

  window.addEventListener("message", (event) => {
    if (event.data.action === "close-modal") {
      document.body.style.overflow = "visible";

      Array.from(document.getElementsByTagName("video")).forEach((video) => {
        video.play();
      });

      root.unmount();
    }
  });

  root.render(
    <Integration
      partner={partner}
      language={language}
      flow={flow_registration}
    />
  );
}

export function initRegistration({ partner, language }) {
  partner = partner || DEFAULT_PARTNER;
  language = language || DEFAULT_LANGUAGE;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);

  document.body.style.overflow = "hidden";

  Array.from(document.getElementsByTagName("video")).forEach((video) => {
    video.pause();
  });

  window.addEventListener("message", (event) => {
    if (event.data.action === "close-modal") {
      document.body.style.overflow = "visible";

      Array.from(document.getElementsByTagName("video")).forEach((video) => {
        video.play();
      });

      root.unmount();
    }
  });

  root.render(
    <Integration partner={partner} language={language} flow={flow_login} />
  );
}

export function initCustomerLogin({ partner, language }) {
  partner = partner || DEFAULT_PARTNER;
  language = language || DEFAULT_LANGUAGE;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);

  document.body.style.overflow = "hidden";

  Array.from(document.getElementsByTagName("video")).forEach((video) => {
    video.pause();
  });

  window.addEventListener("message", (event) => {
    if (event.data.action === "close-modal") {
      document.body.style.overflow = "visible";

      Array.from(document.getElementsByTagName("video")).forEach((video) => {
        video.play();
      });

      root.unmount();
    }
  });

  root.render(
    <Integration
      partner={partner}
      language={language}
      flow={flow_customer_login}
    />
  );
}

export function initSmartCheckIn({
  partner,
  language,
  snr,
  gid,
  siteType,
  env,
}) {

  partner = "adp_MERKUR";
  language = language || DEFAULT_LANGUAGE;
  snr = snr || "";
  gid = gid || "";
  siteType = siteType || "";
  env = env || "";

  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = createRoot(container);

  document.body.style.overflow = "hidden";
  Array.from(document.getElementsByTagName("video")).forEach((video) =>
    video.pause()
  );

  window.addEventListener("message", (event) => {
    if (event.data.action === "close-modal") {
      document.body.style.overflow = "visible";
      Array.from(document.getElementsByTagName("video")).forEach((video) =>
        video.play()
      );
      root.unmount();
    }
  });

  root.render(
    <Integration
      partner={partner}
      language={language}
      flow={smart_check_in}
      snr={snr}
      gid={gid}
      siteType={siteType}
      env={env}
    />
  );
}

const urlParams = new URLSearchParams(window.location.search);
const partner = urlParams.get("partner");
if (partner === "adp_MERKUR") {
  initSmartCheckIn({
    partner,
    language,
    snr: urlParams.get("snr"),
    gid: urlParams.get("gid"),
    siteType: urlParams.get("siteType"),
    env: urlParams.get("env"),
  });
}
